// extracted by mini-css-extract-plugin
module.exports =  {"skillsSection":"CandidateSkillsDisplay-module_skillsSection_c0e5d","skillsBlock":"CandidateSkillsDisplay-module_skillsBlock_a2e5b"};